import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import '../src/assets/theme.css'

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

// banner
import Banner from '@/views/inside/Banner.vue'
Vue.component('Banner', Banner)

// 头条
import Headlines from '@/views/inside/Headlines.vue'
Vue.component('Headlines', Headlines)

// 标题
import Title from '@/views/inside/Title.vue'
Vue.component('Title', Title)

// 文章
import Article from '@/views/inside/Article.vue'
Vue.component('Article', Article)

// 轮播
import Shuffling from '@/views/inside/Shuffling.vue'
Vue.component('Shuffling', Shuffling)

// 长图
import Longfigure from '@/views/inside/Longfigure.vue'
Vue.component('Longfigure', Longfigure)

// 专题
import Project from '@/views/inside/Project.vue'
Vue.component('Project', Project)

// 上市
import Ipolisted from '@/views/inside/Ipolisted.vue'
Vue.component('Ipolisted', Ipolisted)

// 标签页
import Tabs from '@/views/inside/Tabs.vue'
Vue.component('Tabs', Tabs)

// 广告
import Advertising from '@/views/inside/Advertising.vue'
Vue.component('Advertising', Advertising)

// 右边
import Rightbox from '@/views/inside/Rightbox.vue'
Vue.component('Rightbox', Rightbox)

// 文本
import Text from '@/views/inside/Text.vue'
Vue.component('Text', Text)


Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
